var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"brand",attrs:{"to":{ name: 'Dashboard' },"title":_vm.appName}},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":_vm.appName}})])}
var staticRenderFns = []

export { render, staticRenderFns }